import type { RutubeSrcParts } from './types';

// https://rutube.ru/play/embed/<32 hex>/?p=TOKEN
const EMBED_ID_RE = /\/play\/embed\/([0-9a-f]{32})/i;
// Токен приватного видео. В ссылках встречается `?p=TOKEN?r=plemwd` — второй
// параметр приклеен через `?`, а не `&`, поэтому останавливаемся и на нём.
const EMBED_TOKEN_RE = /[?&]p=([^?&]+)/;

/** Достаёт id видео и токен приватного доступа из `src` embed-плеера. */
export function parseRutubeSrc(src: string): RutubeSrcParts {
  return {
    id: src.match(EMBED_ID_RE)?.[1] ?? '',
    token: src.match(EMBED_TOKEN_RE)?.[1] ?? '',
  };
}
